import Sketch from "./module";
var everythingLoaded = setInterval(function () {
  if (/loaded|complete/.test(document.readyState)) {
    clearInterval(everythingLoaded);
    //console.log("loaded evry");
    init();
  }
}, 10);
function init() {
  // console.log("loaded");
  // document.getElementById("loading").style.display = "none";
  // document.getElementById("explore").style.display = "flex";
  // document.getElementById("explore").addEventListener("click",()=>{
  //     document.getElementById("loader").style.display = "none";
  //     let sketch = new Sketch({
  //         dom: document.getElementById("container"),
  //     });
  //     function raf(){
  //         window.requestAnimationFrame(raf)
  //     }
  //     raf();
  // })
  let sketch = new Sketch({
    dom: document.getElementById("container"),
  });
  function raf() {
    window.requestAnimationFrame(raf);
  }
  raf();
}
